import * as _ from "lodash";
import { SelectMenuDefinition } from "../models/grid-fields/select-menu-definition";

/**
 * Checks for valid properties in schema to be included in the Form Definition.
 *
 * Given a generic Form Definition, this method will return an object
 * containing only those properties found in the schema, that also have its
 * type set to a value different than null.
 *
 * Unconditional fields are included, regardless of them appearing in the
 * schema or having null value.
 *
 * @param schema - The schema to be considered
 * @param formDefinition - The generic form definition
 * @param unconditionalFields - Fields that should be included regardless.
 * @returns schemaFormDefinition
 */
export default function buildSchemaCompliantDefinition(
    schema,
    formDefinition,
    unconditionalFields: string[] = []
) {
    const schemaFormDefinition = {};

    for (let field in schema.properties) {
        if (formDefinition.hasOwnProperty(field)) {
            if (schema.properties[field].type !== "null") {
                schemaFormDefinition[field] = formDefinition[field];
            }

            if (schema.properties[field].hasOwnProperty("enum")) {
                schemaFormDefinition[field] = _includeValidEnumValues(
                    schema.properties[field],
                    formDefinition[field]
                );
            }
        }
    }

    unconditionalFields.forEach(field => {
        // Will not duplicate fields, as it is an object (not an array)
        schemaFormDefinition[field] = formDefinition[field];
    });

    return schemaFormDefinition;
}

function _includeValidEnumValues(schemaProperty, fieldDefinition) {
    const definitionCopy = _.cloneDeep(fieldDefinition);
    definitionCopy.definition.items = fieldDefinition.definition.items.filter(
        item => schemaProperty.enum.includes(item.value)
    );

    return definitionCopy;
}
